
export const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.techStack': 'Tech Stack',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.getQuote': 'Get Quote',

  // Company Info
  'company.name': 'Balam Technology',
  'company.tagline': 'Custom software, built with trust.',

  // Hero Section
  'hero.title': 'We build the future with custom software.',
  'hero.subtitle': 'Innovation, trust, modern tech.',
  'hero.cta': 'Contact Us',
  'hero.learnMore': 'Learn More',

  // Services Section
  'services.title': 'Our Services',
  'services.subtitle': 'Modern UI, scalable backends, secure APIs, cloud deployments.',
  'services.getQuote': 'Get a Quote',
  
  'services.website.title': 'Website Development',
  'services.website.description': 'Modern UI with responsive design and optimized performance.',
  'services.website.benefits': 'Fast, SEO-friendly, mobile-first approach',
  
  'services.landing.title': 'Landing Pages',
  'services.landing.description': 'High-converting pages that drive results for your business.',
  'services.landing.benefits': 'Conversion-optimized, A/B tested, analytics-ready',
  
  'services.webapp.title': 'Web Applications',
  'services.webapp.description': 'Scalable web apps with modern architecture and UX.',
  'services.webapp.benefits': 'Scalable backends, secure architecture, cloud-ready',
  
  'services.api.title': 'API Development',
  'services.api.description': 'Secure APIs with robust documentation and monitoring.',
  'services.api.benefits': 'RESTful design, secure endpoints, comprehensive docs',

  // Tech Stack Section
  'techStack.title': 'Our Tech Stack',
  'techStack.subtitle': 'We leverage AWS, React, JavaScript, Tailwind, Serverless, and Monolithic architectures to build robust, scalable solutions.',
  'techStack.architecture.title': 'Architecture That Scales',
  'techStack.architecture.description': 'We choose the right architecture for your needs - from serverless solutions for rapid scaling to monolithic approaches when your project demands it. Every decision is made with performance, maintainability, and your business goals in mind.',
  
  'techStack.aws.description': 'Cloud infrastructure and services',
  'techStack.react.description': 'Modern frontend framework',
  'techStack.javascript.description': 'Core programming language',
  'techStack.tailwind.description': 'Utility-first CSS framework',
  'techStack.serverless.description': 'Scalable serverless architecture',
  'techStack.monolithic.description': 'When architecture demands it',

  // About Section
  'about.title': 'A young company with senior standards.',
  'about.description': 'We are passionate about delivering quality software solutions. Our workflow: discovery → design → develop → deploy.',
  'about.workflow.discovery': 'Discovery',
  'about.workflow.design': 'Design',
  'about.workflow.develop': 'Develop',
  'about.workflow.deploy': 'Deploy',
  'about.satisfaction': 'Client Satisfaction',
  'about.excellence': 'Excellence guaranteed in every project',
  'about.quality': 'Premium Quality',
  'about.delivery': 'On-Time Delivery',
  'about.support': 'Support',
  'about.innovation.title': 'Innovation',
  'about.innovation.description': 'Cutting-edge solutions using the latest technologies',
  'about.trust.title': 'Trust',
  'about.trust.description': 'Reliable partnerships built on transparency',
  'about.modernTech.title': 'Modern Tech',
  'about.modernTech.description': 'Future-proof solutions that scale with your business',

  // Contact Section
  'contact.title': 'Tell us about your project',
  'contact.subtitle': 'Ready to bring your ideas to life? Let\'s discuss your project requirements.',
  'contact.form.name': 'Full Name',
  'contact.form.email': 'Email Address',
  'contact.form.company': 'Company Name',
  'contact.form.project': 'Project Type',
  'contact.form.budget': 'Budget Range',
  'contact.form.message': 'Project Details',
  'contact.form.submit': 'Send Message',
  'contact.form.sending': 'Sending...',
  'contact.form.success': 'Thank you! We\'ll get back to you within 24 hours.',
  'contact.form.error': 'Something went wrong. Please try again or email us directly.',
  'contact.form.charactersLeft': 'characters',
  
  'contact.form.placeholders.name': 'John Doe',
  'contact.form.placeholders.email': 'john@company.com',
  'contact.form.placeholders.company': 'Your Company',
  'contact.form.placeholders.message': 'Tell us about your project requirements, timeline, and any specific features you need...',
  
  'contact.form.projectTypes.select': 'Select a service',
  'contact.form.projectTypes.website': 'Website Development',
  'contact.form.projectTypes.landing': 'Landing Page',
  'contact.form.projectTypes.webapp': 'Web Application',
  'contact.form.projectTypes.api': 'API Development',
  'contact.form.projectTypes.other': 'Other',
  
  'contact.form.budgetRanges.select': 'Select budget',
  'contact.form.budgetRanges.5k10k': '$5K - $10K',
  'contact.form.budgetRanges.10k25k': '$10K - $25K',
  'contact.form.budgetRanges.25k50k': '$25K - $50K',
  'contact.form.budgetRanges.50kplus': '$50K+',

  // CAPTCHA Section
  'contact.form.captcha.title': 'Security Verification',
  'contact.form.captcha.instruction': 'Please solve the math problem to verify you\'re human',
  'contact.form.captcha.refresh': 'Generate new problem',
  'contact.form.captcha.error': 'Incorrect answer. Please solve the math problem correctly.',

  'contact.info.title': 'Get in Touch',
  'contact.info.email': 'Email',
  'contact.info.phone': 'Phone',
  'contact.info.responseTime': 'Response Time',
  'contact.info.responseTimeValue': 'Within 24 hours',
  'contact.followUs': 'Follow Us',

  // Footer
  'footer.description': 'Custom software, built with trust. We create innovative solutions using modern technologies to help your business thrive in the digital age.',
  'footer.quickLinks': 'Quick Links',
  'footer.services': 'Services',
  'footer.copyright': '© 2024 Balam Technology. All rights reserved.',
  'footer.madeWith': 'Powered by Balam Technology',

  // Services list for footer
  'footer.services.website': 'Website Development',
  'footer.services.landing': 'Landing Pages',
  'footer.services.webapp': 'Web Applications',
  'footer.services.api': 'API Development',

  // Common
  'common.required': '*'
};

export default common;
